import React, { forwardRef } from "react";

const FullCapIcon = forwardRef<unknown>(({}, ref) => (
  <svg
    // @ts-ignore
    ref={ref}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C5.9225 1 1 5.9225 1 12H1.56833C1.80667 7.27 5.7025 3.5025 10.4967 3.5025C15.2908 3.5025 19.1867 7.27 19.425 12H23C23 5.9225 18.0775 1 12 1Z"
      fill="white"
    />
    <path
      d="M18.2284 13.5815L12.6634 16.3097C11.6404 15.721 10.3412 15.7436 9.33633 16.5025C7.96736 17.5286 7.67639 19.5022 8.68186 20.9137C9.68733 22.3252 11.6097 22.6338 12.9787 21.6076C13.8663 20.9414 14.2953 19.8706 14.2127 18.8221L18.5677 14.0555C18.7857 13.8131 18.5237 13.4377 18.2284 13.5815Z"
      fill="white"
    />
  </svg>
));

export default FullCapIcon;
